import { Message } from '../types/chatbot'

export const greetings = `👋 Greetings! I am SensAI, your virtual assistant for this lab. Think of me as your trusty guide
through the realm of knowledge. I'm here to provide answers to your questions and offer helpful prompts along the way. Let's embark on this learning adventure together`

export const initQuestions = `Are there any topics you would like to cover?`

export const disclaimer = `AI generates messages from our Terms & Conditions. Occasionally, they may contain inaccuracies or inappropriate content. Help us improve the quality by providing feedback. `

export const initialMessages: Message[] = [
  { sender: 'bot', text: greetings },
  {
    sender: 'bot',
    text: initQuestions,
    type: 'options',
    options: ['What is Amazon VPC', 'Why use Amazon VPC']
  }
]

type ENDPOINT_CONFIGS = {
  websocketProxyEndpoint: string
  restProxyEndpoint: string
}

interface ENDPOINT_MAP_TYPE {
  [key: string]: ENDPOINT_CONFIGS
}
interface NegativeResponse {
  text: string
  options: string[]
  response: string
}

// This used to indicate the feedback versions, in future, we should make this number dynamic and changed based on which page we are on.
export let feedbackVersionNumber = 0

/**
 * Per previous discussion with team, we could have multiple template with feedback response versions, so make it an array here
 */
export const negativeFeedbackTemplate: NegativeResponse[] = [
  {
    text: `It seems my response didn't quite meet your expectations. Could you please share what you found unsatisfactory? Your feedback will help me improve and provide better assistance in the future.`,
    options: [
      'Inaccurate',
      'Out of date',
      'Too short',
      'Too long',
      'Harmful or offensive',
      'Not helpful'
    ],
    response: `Apologies for any confusion caused. I'm committed to continuous improvement and learning. Your input is invaluable in helping me enhance my capabilities. Thanks for taking the time to assist me in refining my skills!`
  }
]

/**
 * This is a map used to dynamic determine the API endpoints.
 * It's expected to be modified based on the needs.
 * It will default to wss://api.ws.jiongran.assistant.skillbuilder.training.aws.dev/ for now
 * Once we have beta api endpoint available, we can change EH team's endpoint here
 * Please feel free to edit this map once we have a real beta/gamma/prod endpoint
 */
export const ENDPOINT_MAP: ENDPOINT_MAP_TYPE = {
  'test.beta.assistant.skillbuilder.training.aws.dev': {
    websocketProxyEndpoint:
      'wss://ws.proxy.beta.assistant.skillbuilder.training.aws.dev/',
    restProxyEndpoint:
      'https://proxy.beta.assistant.skillbuilder.training.aws.dev/assistant/'
  },
  'test.gamma.assistant.skillbuilder.training.aws.dev': {
    websocketProxyEndpoint:
      'wss://ws.proxy.gamma.assistant.skillbuilder.training.aws.dev/',
    restProxyEndpoint:
      'https://proxy.gamma.assistant.skillbuilder.training.aws.dev/assistant/'
  },
  'beta.assistant.skillbuilder.training.aws.dev': {
    websocketProxyEndpoint:
      'wss://ws.proxy.beta.assistant.skillbuilder.training.aws.dev/',
    restProxyEndpoint:
      'https://proxy.beta.assistant.skillbuilder.training.aws.dev/assistant/'
  },
  'gamma.assistant.skillbuilder.training.aws.dev': {
    websocketProxyEndpoint:
      'wss://ws.proxy.gamma.assistant.skillbuilder.training.aws.dev/',
    restProxyEndpoint:
      'https://proxy.gamma.assistant.skillbuilder.training.aws.dev/assistant/'
  },
  'sensaidev.test.events.training.aws.a2z.com': {
    websocketProxyEndpoint:
      'wss://ws.proxy.sensaidev.test.events.training.aws.a2z.com/',
    restProxyEndpoint:
      'https://proxy.sensaidev.test.events.training.aws.a2z.com/assistant/'
  },
  'xinrum.aka.corp.amazon.com': {
    websocketProxyEndpoint:
      'wss://ws.proxy.xinrum.assistant.skillbuilder.training.aws.dev/',
    restProxyEndpoint:
      'https://proxy.xinrum.assistant.skillbuilder.training.aws.dev/assistant/'
  },
  'stihahi.aka.corp.amazon.com': {
    websocketProxyEndpoint:
      'wss://ws.proxy.stihahi.assistant.skillbuilder.training.aws.dev/',
    restProxyEndpoint:
      'https://proxy.stihahi.assistant.skillbuilder.training.aws.dev/assistant/'
  },
  'test.stihahi.assistant.skillbuilder.training.aws.dev': {
    websocketProxyEndpoint:
      'wss://ws.proxy.stihahi.assistant.skillbuilder.training.aws.dev/',
    restProxyEndpoint:
      'https://proxy.stihahi.assistant.skillbuilder.training.aws.dev/assistant/'
  },
  'test.chejenni.assistant.skillbuilder.training.aws.dev': {
    websocketProxyEndpoint:
      'wss://ws.proxy.chejenni.assistant.skillbuilder.training.aws.dev/',
    restProxyEndpoint:
      'https://proxy.chejenni.assistant.skillbuilder.training.aws.dev/assistant/'
  },
  'test.gojie.assistant.skillbuilder.training.aws.dev': {
    websocketProxyEndpoint:
      'wss://ws.proxy.gojie.assistant.skillbuilder.training.aws.dev/',
    restProxyEndpoint:
      'https://proxy.gojie.assistant.skillbuilder.training.aws.dev/assistant/'
  },
  'test.jiongran.assistant.skillbuilder.training.aws.dev': {
    websocketProxyEndpoint:
      'wss://ws.proxy.jiongran.assistant.skillbuilder.training.aws.dev/',
    restProxyEndpoint:
      'https://proxy.gojie.assistant.skillbuilder.training.aws.dev/assistant/'
  },
  'test.yaopa.assistant.skillbuilder.training.aws.dev': {
    websocketProxyEndpoint:
      'wss://ws.proxy.yaopa.assistant.skillbuilder.training.aws.dev/',
    restProxyEndpoint:
      'https://proxy.yaopa.assistant.skillbuilder.training.aws.dev/assistant/'
  }
}
